import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BookingBreadcrumbsService } from '../../services/booking-breadcrumbs.service';
import { IBreadcrumbsService } from '../../../general/interfaces/breadcrumbs-service.interface';
import { Subscription } from 'rxjs/internal/Subscription';
import { LoadingSpinnerService } from 'src/app/services/loading-spinner.service';
import { BookingProductStepService } from '../../services/booking-product-step.service';

@Component({
  selector: 'app-booking-product-page',
  templateUrl: './booking-product.page.html',
  styleUrls: ['./booking-product.page.css']
})
export class BookingProductPageComponent implements OnInit, OnDestroy {
  private initializeSubscription: Subscription;
  private _loading = false;

  constructor(
    private bookingBreadcrumbsService: BookingBreadcrumbsService,
    private bookingProductStepService: BookingProductStepService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.initializeSubscription = this.bookingProductStepService.initialize()
      .subscribe(
        () => {
          this.bookingProductStepService.forward();
          this.loading = false;
        }
      );
  }

  ngOnDestroy(): void {
    if (this.initializeSubscription) {
      this.initializeSubscription.unsubscribe();
      this.initializeSubscription = null;
    }
    this.loading = false;
  }

  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    if (this._loading === value) {
      return;
    }

    this._loading = value;
    if (value) {
      this.loadingSpinnerService.show();
    } else {
      this.loadingSpinnerService.hide();
    }
  }

  get hasActiveBreadcrumbs(): boolean {
    return this.bookingBreadcrumbsService.hasActiveBreadcrumbs;
  }

  get breadcrumbsService(): IBreadcrumbsService {
    return this.bookingBreadcrumbsService;
  }
}
